import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/matthis-d/react-puzzle/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "react-puzzle-game"
    }}>{`React Puzzle Game`}</h1>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`If you use `}<inlineCode parentName="p">{`npm`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save react-puzzle-game
`}</code></pre>
    <p>{`or with `}<inlineCode parentName="p">{`yarn`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add react-puzzle-game
`}</code></pre>
    <h2 {...{
      "id": "main-components"
    }}>{`Main components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-puzzle/puzzle-game"
        }}><inlineCode parentName="a">{`PuzzleGame`}</inlineCode></a>{`: the main wrapper`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-puzzle/puzzle"
        }}><inlineCode parentName="a">{`Puzzle`}</inlineCode></a>{`: the sliced, mixed and clickable image`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      